import styled from 'styled-components'
import { Image, Container, Segment, Card } from 'semantic-ui-react'

import { BasedBodyContainer, BasedFullWidthBackgroundContainer } from '@/components/OtherCustomComponents/style'

export const BodyContainer = styled(BasedBodyContainer)``

export const FullWidthBackgroundContainer = styled(BasedFullWidthBackgroundContainer)`
    background-color: #e2eef9;
`

export const ThemedText = styled.span`
    color: #1b77d2;
`

export const BodySegment = styled(Segment)`
    && {
        font-size: 1em;
        /* margin: -1em; */
    }
`

export const IconsWrapper = styled.div`
    @media (min-width: 992px) {
        padding: 1em;
    }
    &>* {
        margin-bottom: 1em;
    }
`

export const CenterText = styled.div`
    text-align: center;
`

export const ThemedSegment = styled(Segment)`
    &&&&& {
        display: inline;
        background-color: #1b77d2;
        padding: 0.1em 0.5em;
        color: #fff;
    }
`

export const CustomImage = styled(Image)`
    &&&& {
        width: ${({ $width }) => $width};
        height: ${({ $height }) => $height};
        margin: ${({ $margin }) => $margin};
    }
`